import PaintBucketIcon from '@atlaskit/icon/core/paint-bucket';
import * as React from 'react';

export function SvgPaintBucket() {
  return <PaintBucketIcon label="" testId="ads-refreshed-icon" />;
}
